@if (showBaseLayout()) {
  <span
    class="d-flex align-items-center justify-content-end h-100 text-sm fw-semibold text-black bg-cyan-20 py-1 px-2 border-start-0 border-radius-sm">
    <span class="ico ico-Lock"></span>
    <span class="ml-1">
      {{ 'shared:sidepanel-backup.backupStorages.browseStorage.comingSoonDesc' | i18next }}
    </span>
  </span>
} @else if (loaded()) {
  @if (betaAvailable()) {
    <span
      class="d-flex align-items-center justify-content-end text-sm fw-semibold text-black bg-cyan-20 py-1 px-2 border-start-0 border-radius-sm">
      <span class="ico ico-Lock"></span>
      <span class="ml-1">
        <span class="beta-feature-request__message">
          {{ 'shared:betaRequest.installBetaBuild' | i18next }}
        </span>
      </span>
    </span>
  } @else if (requested()) {
    <span
      class="d-flex align-items-center justify-content-end text-sm fw-semibold text-black bg-cyan-20 py-1 px-2 border-start-0 border-radius-sm">
      <span class="ico ico-Lock"></span>
      <span class="ml-1">
        <span class="beta-feature-request__message">
          {{ 'shared:betaRequest.alreadyRequested' | i18next }}
        </span>
      </span>
    </span>
  } @else {
    <span
      class="d-flex align-items-center justify-content-end text-sm fw-semibold text-black bg-danger-20 py-1 px-2 border-start-0 border-radius-sm">
      <span class="ico ico-Lock"></span>
      <span class="ml-1">
        <mbs-button
          [isCtrl]="true"
          [loading]="loading()"
          [size]="buttonSize.sm"
          (click)="request()">
          {{ 'shared:betaRequest.request' | i18next }}
        </mbs-button>
      </span>
    </span>
  }
}
